import AdminBonus from 'components/Admin/Bonus/AdminBonus';
import AdminSettings from 'components/Admin/Settings/AdminSettings';
import { FC } from 'react';

const AdminBonusPage: FC = () => {
	return <AdminBonus />;
};

export default AdminBonusPage;
